var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 2.71429C0 1.99441 0.285969 1.30402 0.794996 0.794996C1.30402 0.285969 1.99441 0 2.71429 0H3.95562C4.73371 0 5.41229 0.530191 5.60138 1.28476L6.60114 5.28652C6.68216 5.61043 6.6658 5.95103 6.5541 6.26568C6.44241 6.58032 6.24035 6.85501 5.97324 7.05533L4.80338 7.93295C4.68124 8.02433 4.655 8.15824 4.68938 8.25143C5.20001 9.6401 6.00635 10.9012 7.05257 11.9474C8.09879 12.9937 9.3599 13.8 10.7486 14.3106C10.8418 14.345 10.9748 14.3188 11.067 14.1966L11.9447 13.0268C12.145 12.7597 12.4197 12.5576 12.7343 12.4459C13.049 12.3342 13.3896 12.3178 13.7135 12.3989L17.7152 13.3986C18.4698 13.5877 19 14.2663 19 15.0453V16.2857C19 17.0056 18.714 17.696 18.205 18.205C17.696 18.714 17.0056 19 16.2857 19H14.25C6.38038 19 0 12.6196 0 4.75V2.71429Z",
    fill: "#068BDC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.5c54cf9b964e10bccce80320ff2599b2.svg";
export { ForwardRef as ReactComponent };